export default "__VITE_ASSET__D3XkQM99__"